/** Wire value stays "Public"; use these labels only in UI. */
export function dilapidationStatusDisplayLabel(status) {
    if (status === "Public")
        return "Published";
    return status;
}
/** Label for a menu option that sets the wire status (e.g. Publish → API "Public"). */
export function dilapidationStatusTargetActionLabel(status) {
    if (status === "Public")
        return "Publish";
    return status;
}
